import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, FormGroup, Label, Col } from "reactstrap";
import { GetProvince, GetTitleName } from "../share/api/MasterDataApi";


export const AddEditAuthorizedModal = ({
  isOpen,
  toggle,
  onSubmit,
  initialData,
  mode,
  copyAddressData
}) => {
  const [formData, setFormData] = useState(initialData);
  // console.log("formData", formData);
  const [locationProvince, setLocationProvince] = useState([]);
  const [listAuthAmphur, setListAuthAmphur] = useState([]);
  const [listAuthTumbon, setListAuthTumbon] = useState([]);
  const [locationCurrentProvince, setLocationCurrentProvince] = useState([]);
  const [listCurrentAmphur, setListCurrentAmphur] = useState([]);
  const [listCurrentTumbon, setListCurrentTumbon] = useState([]);
  const [titleName, setTitleName] = useState([]);
  const [loading, setLoading] = useState(false)
  // console.log("copyAddressData", copyAddressData);
  useEffect(() => {
    setFormData(initialData); // อัปเดตค่าฟอร์มเวลาเปลี่ยนรายการแก้ไข
  }, [initialData]);

  useEffect(() => {
    // setLoading(true)
    GetProvince({ setLocationProvince, setLoading }) // ดึง master data จังหวัด
    GetTitleName({ setTitleName, setLoading }) //ดึงคำนำหน้าชื่อ

  }, []);

  useEffect(() => {
    setLocationCurrentProvince(locationProvince);
  }, [locationProvince])

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSave = () => {
    const { authTitleId, authFullName, authPersonalId } = formData;
    if (authTitleId && authFullName && authPersonalId.length === 13) {
      onSubmit(formData);
      toggle();
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน และเลขบัตรประชาชนต้อง 13 หลัก");
    }
  };

  async function GetAmphurForCopy(values) {

    if (values) {
      let postData = new FormData();
      postData.append("provinceCode", values);

      try {
        const responseAmphur = await fetch("/api/MasterData/getAmphur", {
          method: "POST",
          body: postData
        });
        const amphurData = await responseAmphur.json()
        setListAuthAmphur(amphurData.dataenum);
        // console.log(amphurData.dataenum);

      } catch (err) {
        console.log("err =>" + err);
      }
    } else {
      return;
    }

  }

  async function GetCurTumbonForCopy(values) {
    console.log("values", values);
    if (values) {
      let postData = new FormData();
      postData.append("provinceCode", copyAddressData?.addProvince || copyAddressData?.address?.provinceCode);
      postData.append("amphurCode", values);
      try {
        let responseTumbon = await fetch("/api/MasterData/getTumbon", {
          method: "POST",
          body: postData
        });
        const tumbonData = await responseTumbon.json()
        setListAuthTumbon(tumbonData.dataenum);

      } catch (err) {
        // console.log("err =>" + err);
      }

    } else {
      return;
    }
  };

  const handleCopyAddress = async (e) => {
    if (e.target.checked && copyAddressData) {
      if (typeof GetAmphurForCopy === "function") {
        await GetAmphurForCopy(copyAddressData?.addProvince ?? copyAddressData?.address?.provinceCode);
      }
      if (typeof GetCurTumbonForCopy === "function") {
        await GetCurTumbonForCopy(copyAddressData?.addDistrict ?? copyAddressData?.address?.amphurCode);
      }

      setFormData((prev) => ({
        ...prev,
        authAddressNo: copyAddressData.addNo || copyAddressData?.address?.addressNo || "",
        authAddressMoo: copyAddressData.addMoo || copyAddressData.address?.moo || "",
        authAddressSoi: copyAddressData.addSoi || copyAddressData.address?.soi || "",
        authAddressStreet: copyAddressData.addStreet || copyAddressData.address?.street || "",
        authAddressProvince: copyAddressData.addProvince || copyAddressData.address?.provinceCode || "",
        authAddressDistrict: copyAddressData.addDistrict || copyAddressData.address?.amphurCode || "",
        authAddressTumbon: copyAddressData.addTumbon || copyAddressData.address?.tumbonCode || "",
        authAddressPostCode: copyAddressData.postcode || copyAddressData.address?.postcode || "",
        authAddressLocationId: copyAddressData.locationId || copyAddressData.address?.locationId || "",
      }));
    } else {
      // reset
      setFormData((prev) => ({
        ...prev,
        authAddressNo: "",
        authAddressMoo: "",
        authAddressSoi: "",
        authAddressStreet: "",
        authAddressProvince: "",
        authAddressDistrict: "",
        authAddressTumbon: "",
        authAddressPostCode: "",
        authAddressLocationId: "",
      }));
    }
  };



  async function GetAmphur(e) {
    if (e) {
      let { value } = e.target;
      // console.log(e.target.value);
      let postData = new FormData();
      postData.append("provinceCode", value);

      try {
        const responseAmphur = await fetch("/api/MasterData/getAmphur", {
          method: "POST",
          body: postData
        });
        const amphurData = await responseAmphur.json()
        setListAuthAmphur(amphurData.dataenum);
        // console.log(amphurData.dataenum);

      } catch (err) {
        // console.log("err =>" + err);
      }
    } else {
      return;
    }
  }
  // ดึง master data ตำบล
  async function GetTumbon(e) {
    // console.log("e",e.target.value);
    if (e) {
      let postData = new FormData();
      postData.append("provinceCode", formData.authAddressProvince);
      postData.append("amphurCode", e.target.value);
      try {
        let responseTumbon = await fetch("/api/MasterData/getTumbon", {
          method: "POST",
          body: postData
        });
        const tumbonData = await responseTumbon.json()
        setListAuthTumbon(tumbonData.dataenum);
        // setLocationTumbon(tumbonData.dataenum);

      } catch (err) {
        // console.log("err =>" + err);
      }

    } else {
      return;
    }
  };

  async function GetLocationsId(e) {

    let tumbonId = e.target.value;
    let provinceId = formData.authAddressProvince;
    let amphurId = formData.authAddressDistrict;

    let postData = new FormData();
    postData.append("provinceCode", provinceId);
    postData.append("amphurCode", amphurId);
    postData.append("tumbonCode", tumbonId);
    try {
      let res = await fetch("/api/MasterData/getLocationId", {
        method: "POST",
        body: postData
      });
      const locationId = await res.json()

      let setLocationId = locationId.dataenum.map(({ locationId }) => locationId).join().toString();

      setFormData((prev) => ({
        ...prev,
        authAddressLocationId: setLocationId || "",
      }));

    } catch (err) {
      console.log("err =>" + err);
    }
  }

  async function GetAmphurIsOpen() {
    if (mode != "add") {
      // console.log("formData.authAddressProvince",formData.authAddressProvince);
      let postData = new FormData();
      postData.append("provinceCode", formData.authAddressProvince);

      try {
        const responseAmphur = await fetch("/api/MasterData/getAmphur", {
          method: "POST",
          body: postData
        });
        const amphurData = await responseAmphur.json()
        setListAuthAmphur(amphurData.dataenum);

        // console.log("amphurData.dataenum", amphurData.dataenum);

      } catch (err) {
        // console.log("err =>" + err);
      }
    }

  }
  // ดึง master data ตำบล
  async function GetTumbonIsOpen() {
    if (mode != "add") {
      let postData = new FormData();
      postData.append("provinceCode", formData.authAddressProvince);
      postData.append("amphurCode", formData.authAddressDistrict);
      try {
        let responseTumbon = await fetch("/api/MasterData/getTumbon", {
          method: "POST",
          body: postData
        });
        const tumbonData = await responseTumbon.json()
        // console.log("tumbonData", tumbonData);
        setListAuthTumbon(tumbonData.dataenum);

      } catch (e) {

      }
    }
  }



  useEffect(() => {
    GetAmphurIsOpen();
    GetTumbonIsOpen();
    GetAmphurCurrentIsOpen();
    GetTumbonCurrentIsOpen();
  }, [mode, isOpen, formData])


  async function GetAmphurCurrent(e) {
    let postData = new FormData();
    postData.append("provinceCode", e.target.value);
    const res = await fetch("/api/MasterData/getAmphur", {
      method: "POST",
      body: postData
    });
    const data = await res.json();
    setListCurrentAmphur(data.dataenum); // ใช้ร่วมกันได้ หรือสร้างอีกชุดก็ได้
  }

  async function GetTumbonCurrent(e) {
    let postData = new FormData();
    postData.append("provinceCode", formData.currentAddressProvince);
    postData.append("amphurCode", e.target.value);
    const res = await fetch("/api/MasterData/getTumbon", {
      method: "POST",
      body: postData
    });
    const data = await res.json();
    setListCurrentTumbon(data.dataenum); // ใช้ร่วมกันได้ หรือสร้างอีกชุด
  }

  async function GetLocationsIdCurrent(e) {
    let postData = new FormData();
    postData.append("provinceCode", formData.currentAddressProvince);
    postData.append("amphurCode", formData.currentAddressDistrict);
    postData.append("tumbonCode", e.target.value);
    const res = await fetch("/api/MasterData/getLocationId", {
      method: "POST",
      body: postData
    });
    const data = await res.json();
    const locationId = data.dataenum[0]?.locationId ?? "";
    setFormData(prev => ({
      ...prev,
      currentAddressLocationId: locationId
    }));
  }

  async function GetAmphurCurrentIsOpen() {
    if (mode != "add") {
      // console.log("formData.authAddressProvince",formData.authAddressProvince);
      let postData = new FormData();
      postData.append("provinceCode", formData.currentAddressProvince);

      try {
        const responseAmphur = await fetch("/api/MasterData/getAmphur", {
          method: "POST",
          body: postData
        });
        const amphurData = await responseAmphur.json()
        setListCurrentAmphur(amphurData.dataenum);

        // console.log("amphurData.dataenum", amphurData.dataenum);

      } catch (err) {
        // console.log("err =>" + err);
      }
    }

  }
  // ดึง master data ตำบล
  async function GetTumbonCurrentIsOpen() {
    if (mode != "add") {
      let postData = new FormData();
      postData.append("provinceCode", formData.currentAddressProvince);
      postData.append("amphurCode", formData.currentAddressDistrict);
      try {
        let responseTumbon = await fetch("/api/MasterData/getTumbon", {
          method: "POST",
          body: postData
        });
        const tumbonData = await responseTumbon.json()
        // console.log("tumbonData", tumbonData);
        setListCurrentTumbon(tumbonData.dataenum);

      } catch (e) {

      }
    }
  }


  const handleCopyCurrentFromMain = async (e) => {
    if (e.target.checked) {
      if (typeof GetAmphurCurrent === "function") {
        await GetAmphurCurrent({ target: { value: formData.authAddressProvince } });
      }
      if (typeof GetTumbonCurrent === "function") {
        await GetTumbonCurrent({ target: { value: formData.authAddressDistrict } });
      }

      setFormData((prev) => ({
        ...prev,
        currentAddressNo: prev.authAddressNo || "",
        currentAddressMoo: prev.authAddressMoo || "",
        currentAddressSoi: prev.authAddressSoi || "",
        currentAddressStreet: prev.authAddressStreet || "",
        currentAddressProvince: prev.authAddressProvince || "",
        currentAddressDistrict: prev.authAddressDistrict || "",
        currentAddressTumbon: prev.authAddressTumbon || "",
        currentAddressPostCode: prev.authAddressPostCode || "",
        currentAddressLocationId: prev.authAddressLocationId || "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        currentAddressNo: "",
        currentAddressMoo: "",
        currentAddressSoi: "",
        currentAddressStreet: "",
        currentAddressProvince: "",
        currentAddressDistrict: "",
        currentAddressTumbon: "",
        currentAddressPostCode: "",
        currentAddressLocationId: "",
      }));
    }
  };



  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ maxWidth: "870px", width: "100%" }}
      scrollable
      backdrop={'static'}
      keyboard={false}
    >
      <ModalHeader toggle={toggle}>
        {mode === "edit" ? "แก้ไขผู้มีอำนาจ" : "เพิ่มผู้มีอำนาจ"}
      </ModalHeader>
      <ModalBody>
        <div className="px-4 pt-3">
          <FormGroup row>
            <Label for="authFullName">
              ชื่อ - สกุล<span className="require-input">*</span>
            </Label>
            <div className="d-flex justify-content-start px-6">
              <div className="flex-grow-1">
                <Input
                  type="select"
                  value={formData.authTitleId}
                  onChange={handleChange("authTitleId")}
                  className="rounded-pill rounded-end text-center input-color"
                >
                  <option defaultValue={"คำนำหน้า"}>คำนำหน้า</option>
                  {titleName?.map((title, i) => (
                    <option
                      key={title.titleCode}
                      value={title.titleCode}
                    >
                      {title.titleThai}
                    </option>
                  ))}
                </Input>
              </div>
              <div className="w-75">
                <Input
                  type="text"
                  value={formData.authFullName}
                  onChange={handleChange("authFullName")}
                  placeholder="ชื่อ-สกุล"
                  className="rounded-pill rounded-start text-center input-color"
                />
              </div>
            </div>
          </FormGroup>

          <FormGroup row>
            <Label for="authPersonalId">
              เลขบัตรประจำตัวประชาชน<span className="require-input">*</span>
            </Label>
            <Input
              type="text"
              maxLength={13}
              value={formData.authPersonalId}
              // onChange={handleChange("authPersonalId")}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                handleChange("authPersonalId")({ target: { value: onlyNums } });
              }}
              className="rounded-pill text-center input-color px-6"
            />
          </FormGroup>
        </div>

        <Label className="px-4">ที่อยู่ตามทะเบียนบ้าน<span className="require-input">*</span></Label>
        <FormGroup className="px-5 mt-2">
          <Input
            type="checkbox"
            className="cus-type me-2"
            onClick={(e) => handleCopyAddress(e)}
          />
          <Label>ใช้ที่อยู่ตามที่อยู่สถานประกอบการ</Label>
        </FormGroup>
        <div className="px-5 mt-2">
          <FormGroup row>
            <Label sm={2}>เลขที่<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressNo}
                onChange={handleChange("authAddressNo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>หมู่ที่</Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressMoo}
                onChange={handleChange("authAddressMoo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={2}>ซอย</Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressSoi}
                onChange={handleChange("authAddressSoi")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>ถนน</Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressStreet}
                onChange={handleChange("authAddressStreet")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={2}>จังหวัด<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressProvince}
                // onChange={handleChange("authAddressProvince")}
                className="rounded-pill text-center input-color"
                type="select"
                onChange={async (e) => {
                  handleChange("authAddressProvince")(e);
                  setFormData(prev => ({
                    ...prev,
                    authAddressDistrict: "",
                    authAddressTumbon: ""
                  }));
                  await GetAmphur(e);
                }}
              >
                <option defaultValue="กรุณาเลือกจังหวัด">
                  กรุณาเลือกจังหวัด
                </option>
                {locationProvince?.map(province => (
                  <option
                    key={province.provinceCode}
                    value={province.provinceCode}
                  >
                    {province.provinceName}
                  </option>
                ))}
              </Input>

            </Col>
            <Label sm={2}>อำเภอ/เขต<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressDistrict}
                onChange={async (e) => {
                  handleChange("authAddressDistrict")(e);
                  setFormData(prev => ({
                    ...prev,
                    authAddressTumbon: ""
                  }));
                  await GetTumbon(e);
                }}
                className="rounded-pill text-center input-color"
                type="select"
              >
                <option defaultValue="กรุณาเลือกอำเภอ/เขต" >
                  กรุณาเลือกอำเภอ/เขต
                </option>
                {listAuthAmphur?.map(amphur => (
                  <option
                    key={amphur.amphurCode}
                    value={amphur.amphurCode}>
                    {amphur.amphurName}
                  </option>
                ))}
              </Input>

            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={2}>ตำบล/แขวง<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressTumbon}
                // onChange={handleChange("authAddressTumbon")}
                className="rounded-pill text-center input-color"
                type="select"
                onChange={(e) => {
                  GetLocationsId(e);
                  handleChange("authAddressTumbon")(e);
                }}
              >
                <option defaultValue="กรุณาเลือกตำบล/แขวง">
                  กรุณาเลือกตำบล/แขวง
                </option>
                {listAuthTumbon?.map(tumbon => (
                  <option
                    key={tumbon.tumbonCode}
                    value={tumbon.tumbonCode}
                  >
                    {tumbon.tumbonName}
                  </option>
                ))}
              </Input>
            </Col>
            <Label sm={2}>รหัสไปรษณีย์<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.authAddressPostCode}
                onChange={handleChange("authAddressPostCode")}
                className="rounded-pill text-center input-color"
                maxLength={5}
                type="text"
              />
            </Col>
          </FormGroup>
        </div>

        <Label className="px-4 mt-4">ที่อยู่ปัจจุบัน<span className="require-input">*</span></Label>
        <FormGroup className="px-5 mt-2">
          <Input
            type="checkbox"
            className="cus-type me-2"
            onClick={(e) => handleCopyCurrentFromMain(e)}
          />
          <Label>ใช้ที่อยู่ตามที่อยู่ตามทะเบียนบ้าน</Label>
        </FormGroup>
        <div className="px-5 mt-2">
          <FormGroup row>
            <Label sm={2}>เลขที่<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressNo}
                onChange={handleChange("currentAddressNo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>หมู่ที่</Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressMoo}
                onChange={handleChange("currentAddressMoo")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>ซอย</Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressSoi}
                onChange={handleChange("currentAddressSoi")}
                className="rounded-pill text-center input-color"
              />
            </Col>
            <Label sm={2}>ถนน</Label>
            <Col sm={4}>
              <Input
                value={formData.currentAddressStreet}
                onChange={handleChange("currentAddressStreet")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>จังหวัด<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.currentAddressProvince}
                className="rounded-pill text-center input-color"
                onChange={async (e) => {
                  handleChange("currentAddressProvince")(e);
                  setFormData(prev => ({
                    ...prev,
                    currentAddressDistrict: "",
                    currentAddressTumbon: ""
                  }));
                  await GetAmphurCurrent(e);
                }}
              >
                <option defaultValue="">กรุณาเลือกจังหวัด</option>
                {locationCurrentProvince?.map(province => (
                  <option key={province.provinceCode} value={province.provinceCode}>
                    {province.provinceName}
                  </option>
                ))}
              </Input>
            </Col>
            <Label sm={2}>อำเภอ/เขต<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.currentAddressDistrict}
                className="rounded-pill text-center input-color"
                onChange={async (e) => {
                  handleChange("currentAddressDistrict")(e);
                  setFormData(prev => ({
                    ...prev,
                    currentAddressTumbon: ""
                  }));
                  await GetTumbonCurrent(e);
                }}
              >
                <option defaultValue="">กรุณาเลือกอำเภอ/เขต</option>
                {listCurrentAmphur?.map(amphur => (
                  <option key={amphur.amphurCode} value={amphur.amphurCode}>
                    {amphur.amphurName}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm={2}>ตำบล/แขวง<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="select"
                value={formData.currentAddressTumbon}
                className="rounded-pill text-center input-color"
                onChange={(e) => {
                  GetLocationsIdCurrent(e);
                  handleChange("currentAddressTumbon")(e);
                }}
              >
                <option defaultValue="">กรุณาเลือกตำบล/แขวง</option>
                {listCurrentTumbon?.map(tumbon => (
                  <option key={tumbon.tumbonCode} value={tumbon.tumbonCode}>
                    {tumbon.tumbonName}
                  </option>
                ))}
              </Input>
            </Col>
            <Label sm={2}>รหัสไปรษณีย์<span className="require-input">*</span></Label>
            <Col sm={4}>
              <Input
                type="text"
                maxLength={5}
                value={formData.currentAddressPostCode}
                onChange={handleChange("currentAddressPostCode")}
                className="rounded-pill text-center input-color"
              />
            </Col>
          </FormGroup>
        </div>


      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          ยกเลิก
        </Button>
        <Button color="primary" onClick={handleSave}>
          บันทึก
        </Button>
      </ModalFooter>
    </Modal>
  );
};
